module.exports = __webpack_public_path__ + "static/media/logo-new.8de0dcd4.svg";